import { action } from 'satcheljs';
export default action('MARK_ITEMS_AS_READ_STORE_UPDATE', function (itemIds, isReadValue) {
    return {
        itemIds: itemIds,
        isReadValue: isReadValue,
    };
});
//# sourceMappingURL=markItemsAsReadStoreUpdate.js.map